export default __webpack_public_path__ + "static/media/about.535d93a7.svg";